// Maximum number of rows returned from autocomplete/search endpoints.
export const SEARCH_RESULT_LIMIT = 20;

// Minimum query length before a search is allowed to hit the API.
export const MIN_SEARCH_QUERY_LENGTH = 1;

// User search uses a higher minimum to avoid noisy single-character substring
// matches against usernames.
export const MIN_USER_SEARCH_QUERY_LENGTH = 2;
